<ion-content class="container">
  <div class="tabs-container">
    <div class="mt-10 d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb">
      <img (click)="onClickBreadcrumExpence()" src="././assets/icon/backArrow.svg" class="cp">
      <label class="font_semibold fs-18 fs_16ForMobile ml-10 mt-5 black_color">
        <span class="cp" (click)="onClickBreadcrumExpence()">Elcm</span> /
        <span [style.color]="buttonColorName">Logs</span>
      </label>
    </div>
    <div class="card">
      <ion-row *ngIf="!router.url.includes('Setup')">
        <ion-col size-sm="10" size-md="7" size-lg="7" size-xs="10" class="pl-15 pr-0 pb-0">
          <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup')">
            <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
              (selectedTabChange)="tabTypeChanged($event)">
              <mat-tab label="Updated Elcm Offer">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      delete
                    </span> Offer and Appoinment</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="Updated Elcm Probation">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      update
                    </span>Probation</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="Updated Elcm Exit">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      update
                    </span>Exit</span>
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </div>
        </ion-col>

      </ion-row>
    </div>

    <div class="card  employeeTab">
      <ion-row>
        <ion-col size="2" class="mt-10">
          <!-- <div class="formLabelRegularfs16 mb-5">
            Year
          </div> -->
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
              (selectionChange)="changeByYear($event.value)">
              <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                {{sharedService.transformYearToFyFormat(item.year)}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ion-col>
        <ion-col class="mt-10">
          <label>
            <ion-label class="fs-14 fs_12ForMobile font_regular pr-10 black_color ml-10 ">Show</ion-label>
            <mat-form-field class="w70px mat-height40 mat-input-style">
              <mat-select placeholder="Select" placeholder="Select" (selectionChange)="DislaySelectedRecord($event)"
                [value]="25">
                <mat-option [value]="2">2</mat-option>
                <mat-option [value]="25">25</mat-option>
                <mat-option [value]="50">50</mat-option>
                <mat-option [value]="75">75</mat-option>
                <mat-option [value]="100">100</mat-option>
              </mat-select>
            </mat-form-field>
            <ion-label class="fs-14 fs_12ForMobile font_regular pl-10 black_color">entries</ion-label>
          </label>
        </ion-col>

      </ion-row>
      <div class="p-10 m-20" *ngIf="selectedTypeTabName=='Updated Elcm Exit'">

        <div class="table-container">


          <table class="custom-table rounded-header">
            <thead>
              <tr>
                <th *ngFor="let item of exitColumnHeaderInfo" class="fs-14 fs_12ForMobile font_bold cl-black">
                  <div class="p-5 verticle-center justify-content-space-between icon-style">
                    {{ item?.label }}
                    <span *ngIf="item.isMandatory" class="red-cl">&nbsp;*</span>
                    <div class="d-flex flex-column ml-10">
                      <i (click)="onSortAssending(item.sortingName)" class="material-icons materialIconsHeight cp">
                        arrow_drop_up
                      </i>
                      <i (click)="onSortDesending(item.sortingName)" class="material-icons materialIconsHeight cp">
                        arrow_drop_down
                      </i>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr *ngFor="let item of paginatedData">
                <td class="fs-12 font_regular">{{ item.columnName }}</td>
                <td class="fs-12 font_regular">{{ item.band }}</td>
                <td class="fs-12 font_regular">{{ item.grade }}</td>
                <td class="fs-12 font_regular" matTooltip="{{ item.oldValue }}" matTooltipClass="custom-tooltip"
                  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px;">
                  {{ item.oldValue }}
                </td>

                <td class="fs-12 font_regular" matTooltip="{{ item.newValue }}" matTooltipClass="custom-tooltip"
                  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 200px;">
                  {{ item.newValue }}
                </td>
                <td class="fs-12 font_regular"> {{ item.firstName +"  " +item.lastName}} </td>
                <td class="fs-12 font_regular">{{ item.updatedAt | date: 'dd-MM-yyyy' }}</td>
              </tr>
            </tbody>
          </table>

          <!-- Pagination Controls -->
          <div class="custom-pagination d-flex align-items-center justify-content-end m-20 gap-2 float-right">
            <button class="pg-btn" (click)="page = page - 1" [disabled]="page === 1">&lt;</button>

            <span class="pg-page">{{ page }}</span>
            <span>of {{ totalPages }}</span>

            <button class="pg-btn" (click)="page = page + 1" [disabled]="page === totalPages">&gt;</button>
          </div>


        </div>
        <div class="mt-10" style="font-weight: bold;">
          {{updateLogs.length}} entries
        </div>
      </div>






    </div>

  </div>

</ion-content>